import * as mt from "./mutation-types";

export default {
  [mt.SETS_SET](state, value) {
    state.sets = Array.from(new Set([...state.sets, ...value]));
  },
  [mt.TAGS_SET](state, value) {
    state.tags = Array.from(new Set([...state.tags, ...value]));
  },
  [mt.COMPRESS_SET](state, value) {
    state.compress = value;
  },
};
